// export const rootApiUrl = "http://115.187.50.198:8500";
// export const rootApiUrl = "https://testbe.aestheticsconsults.com.au";
export const rootApiUrl= "https://api.aestheticsconsults.com.au";
// export const webRootApiUrl = "https://testapp.aestheticsconsults.com.au";
// export const webRootApiUrl = "http://localhost:3000";
export const webRootApiUrl= "https://app.aestheticsconsults.com.au";
// export const webRootApiUrl = process.env.REACT_APP_WEB_API_URL;
// export const rootApiUrl = process.env.REACT_APP_ROOT_API_URL;
// export const rootApiUrl = "http://localhost:8500";
